import {
  ComplianceEntity,
  ComplianceEntityForm,
  NullableComplianceEntityTaxClassification
} from "@wingspanhq/wingspan-api-sdk";
import { CountryCode } from "libphonenumber-js";
import { FormDataBusinessInformation } from ".";
import { DeepPartial } from "../../../../utils";
import { FederalTaxClassification } from "../../types";
import { phoneNumberToFormData } from "../FormPartialPhoneNumber";

function getTaxClassification(
  entity: ComplianceEntity
): FederalTaxClassification | undefined {
  switch (entity.form) {
    case ComplianceEntityForm.SOLE_PROPRIETORSHIP:
      return "SoleProprietorship";
    case ComplianceEntityForm.PARTNERSHIP:
      return "Partnership";
    case ComplianceEntityForm.NON_PROFIT:
      return "NotForProfitOrganization";
    case ComplianceEntityForm.CORPORATION:
      switch (entity.taxClassification) {
        case NullableComplianceEntityTaxClassification.TAXED_AS_S_CORPORATION:
          return "CorporationS";
        case NullableComplianceEntityTaxClassification.TAXED_AS_C_CORPORATION:
          return "CorporationC";
        default:
          return undefined;
      }
    case ComplianceEntityForm.LIMITED_LIABILITY:
      switch (entity.taxClassification) {
        case NullableComplianceEntityTaxClassification.TAXED_AS_DISREGARDED_ENTITY:
          return "LlcSingleMember";
        case NullableComplianceEntityTaxClassification.TAXED_AS_S_CORPORATION:
          return "LlcCorporationS";
        case NullableComplianceEntityTaxClassification.TAXED_AS_C_CORPORATION:
          return "LlcCorporationC";
        case NullableComplianceEntityTaxClassification.TAXED_AS_PARTNERSHIP:
          return "LlcPartnership";
        default:
          return undefined;
      }
    default:
      return undefined;
  }
}

export function getProfileDataBusinessV3(
  entity?: ComplianceEntity
): DeepPartial<FormDataBusinessInformation> {
  const address = entity?.physicalAddress;
  const country = entity?.jurisdictionCountry || address?.country || "US";

  return {
    legalBusinessName: entity?.legalName || undefined,
    dba: entity?.doingBusinessAs || undefined,
    taxClassification: entity ? getTaxClassification(entity) : undefined,
    website: entity?.websiteUrl || undefined,
    phone: entity?.phoneNumber
      ? phoneNumberToFormData(entity.phoneNumber, country as CountryCode)
      : undefined,
    address: {
      addressLine1: address?.line1,
      addressLine2: address?.line2,
      city: address?.city,
      state: address?.state,
      postalCode: address?.postalCode
    }
  };
}
